import styled, { css } from 'styled-components';
import { visuallyHidden } from '@klv/shared/styles/accessibility';
import Typography from '@klv/atoms/typography';
import type { IKlaviyoStatus } from '../types';

const indicatorSize = '1.2rem';

export const HiddenText = styled.span`
  ${visuallyHidden}
`;

export const Indicator = styled.div<IKlaviyoStatus>`
  ${({ $indicator, theme }) => css`
    background-color: ${$indicator && theme?.klaviyoStatusIndicator?.[$indicator]?.indicatorColor ? theme.klaviyoStatusIndicator[$indicator].indicatorColor : theme.klaviyoStatusIndicator.fallback.indicatorColor};
    border-radius: 50%;
    height: ${indicatorSize};
    width: ${indicatorSize};
  `}
`;

export const IndicatorLink = styled.a`
  align-items: center;
  column-gap: 0.8rem;
  display: flex;
  text-decoration: none;
`;

export const StatusText = styled(Typography)`
  text-transform: lowercase;

  &::first-letter {
    text-transform: uppercase;
  }

  span {
    font-size: 1.6rem;
    margin: 0 0 0 0.4rem;
  }
`;

export const StyledKlaviyoStatusIndicator = styled.div`
  column-gap: 0.8rem;

  ${StatusText},
  ${IndicatorLink} {
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 4rem;
  }
  ${Indicator} {
    height: 0.8rem;
    width: 0.8rem;
  }
`;
